import { useNavigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import BuildingIcon from "../components/Configuration/BuildingIcon";
import { DTOBuilding } from "../types/building";
import RoundPageStep from "../components/Round/RoundPageStep";
import StartRoundPage from "../components/Round/StartRoundPage";
import { useGlobalData } from "../components/GlobalDataProvider";

const Round = () => {
  const navigate = useNavigate();
  const globalHandler = useGlobalData();

  const buildings = globalHandler.buildings;

  const onSelectBuilding = (id: number) => {
    navigate("/round/building/" + id.toString());
  };

  return (
    <>
      <Routes>
        <Route element={<RoundPageStep />} path="/:roundId/:stepIndex/:moduleIndex?/:BLFIndex?" />
        <Route element={<StartRoundPage />} path="/building/:buildingId" />
        <Route
          element={
            <>
              <h1>Rondering</h1>
              <h4>Klicka på en byggnad för att starta en rondering</h4>
              <ul className="list-group list-group-flush align-items-middle">
                {buildings ? (
                  buildings.map((b, i) => (
                    <li key={b.id} className={"list-group-item "}>
                      <BuildingIcon building={b} onSelectBuilding={(bb: DTOBuilding) => onSelectBuilding(bb.id)} />
                    </li>
                  ))
                ) : (
                  <></>
                )}
              </ul>
            </>
          }
          path="*"
        />
      </Routes>
    </>
  );
};

export default Round;
